import React__default, { useRef, useState, useEffect } from 'react';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends, createForOfIteratorHelperLoose as _createForOfIteratorHelperLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';

var _excluded = ["items", "className", "children", "setHiddenItems", "renderItem"];
var TOGGLE_BTN_ID = "COLLAPSABLE_HORIZONTAL_NAV_TOGGLE";
var nodeListToElementList = function nodeListToElementList(nodes) {
  var elements = [];
  for (var _iterator = _createForOfIteratorHelperLoose(nodes), _step; !(_step = _iterator()).done;) {
    var n = _step.value;
    if (n instanceof Element) {
      elements.push(n);
    }
  }
  return elements;
};
var splitItems = function splitItems(ref, parentRef, items, offset) {
  var _parentRef$current;
  if (offset === void 0) {
    offset = 0;
  }
  var toggleButton = document.getElementById(TOGGLE_BTN_ID);
  if (!ref.current || !parentRef.current) {
    return {
      visible: [],
      hidden: items
    };
  }
  var nodes = nodeListToElementList(ref.current.childNodes).filter(function (x) {
    return x.id !== TOGGLE_BTN_ID;
  });
  var parentWidth = ((_parentRef$current = parentRef.current) == null ? void 0 : _parentRef$current.clientWidth) || 0;
  var maxAvailableWidth = parentWidth - offset;
  var visible = [];
  var hidden = [];
  var childrenWidth = (toggleButton == null ? void 0 : toggleButton.offsetWidth) || 0;
  var totalWidth = childrenWidth + 5;

  /* eslint-disable unicorn/no-for-loop */
  for (var i = 0; i < nodes.length; i++) {
    totalWidth += nodes[i].offsetWidth;
    if (totalWidth > maxAvailableWidth) {
      hidden.push(items[i]);
    } else {
      visible.push(items[i]);
    }
  }
  /* eslint-enable unicorn/no-for-loop */

  return {
    visible: visible,
    hidden: hidden
  };
};
var CollapsableHorizontalNav = function CollapsableHorizontalNav(_ref) {
  var items = _ref.items,
    className = _ref.className,
    children = _ref.children,
    setHiddenItems = _ref.setHiddenItems,
    renderItem = _ref.renderItem,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var itemsRef = useRef(null);
  var parentRef = useRef(null);
  var _useState = useState([]),
    visibleItems = _useState[0],
    setVisibleItems = _useState[1];
  var _useState2 = useState(true),
    resetted = _useState2[0],
    setResetted = _useState2[1];
  var showToggle = visibleItems.length < items.length;
  var onResize = function onResize() {
    setResetted(true);
  };
  useEffect(function () {
    window.addEventListener("resize", onResize);
    return function () {
      if (onResize) {
        window.removeEventListener("resize", onResize);
      }
    };
  });
  useEffect(function () {
    if (resetted === true) {
      setTimeout(function () {
        var _splitItems = splitItems(itemsRef, parentRef, items),
          visible = _splitItems.visible,
          hidden = _splitItems.hidden;
        setVisibleItems(visible);
        setHiddenItems(hidden);
        setResetted(false);
      }, 0);
    }
  }, [resetted]);
  useEffect(function () {
    setResetted(true);
  }, [itemsRef]);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: parentRef,
    className: className
  }), /*#__PURE__*/React__default.createElement("nav", {
    ref: itemsRef,
    style: {
      opacity: resetted ? 0 : 1,
      visibility: resetted ? "hidden" : "visible",
      pointerEvents: resetted ? "none" : "inherit"
    }
  }, (resetted ? items : visibleItems).map(function (x) {
    return renderItem(x);
  }), /*#__PURE__*/React__default.createElement("div", {
    id: TOGGLE_BTN_ID,
    style: {
      display: "inline-block",
      opacity: showToggle ? "1" : "0",
      visibility: showToggle ? "visible" : "hidden",
      pointerEvents: showToggle ? "inherit" : "none"
    }
  }, children)));
};

export { CollapsableHorizontalNav };
//# sourceMappingURL=index.js.map
